import React, { useRef, useState, useEffect } from "react";
import iossequenceVideo from "../images/ios-sequence.mp4";
import { Link } from "react-router-dom";
import Header from "./common/Header";
import Footer from "./common/Footer";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
const IosGuide = () => {
    const { t } = useTranslation();
  const [scrollTop, setScrollTop] = useState(0);
  const [isActive, setIsActive] = useState(false);
  function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
      const mql = window.matchMedia(query);
      const handler = (e) => setMatches(e.matches);
      mql.addEventListener("change", handler);
      setMatches(mql.matches);
      return () => mql.removeEventListener("change", handler);
    }, [query]);
    return matches;
  }

  const isDesktop = useMediaQuery("(min-width: 1402px)");
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isDesktop) return;
    const handleScroll = () => {
      setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
    };

    const handleResize = () => {
      if (wrapperRef.current) {
        document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      }
    };
    if (wrapperRef.current) {
      document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      document.body.style.overflow = "auto";

      wrapperRef.current.style.transition = "transform 0.3s ease-out";
      wrapperRef.current.style.position = "fixed";
      wrapperRef.current.style.top = "0";
      wrapperRef.current.style.left = "0";
      wrapperRef.current.style.width = "100%";
      wrapperRef.current.style.padding = "0";
      wrapperRef.current.style.zIndex = "2";
      wrapperRef.current.style.display = "block";
      wrapperRef.current.style.backfaceVisibility = "hidden";
    }
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, wrapperRef?.current?.offsetHeight]);
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
    }
  }, [scrollTop]);
  useEffect(() => {
    document.body.style.backgroundColor = "#000000";
    return () => {
      document.body.style = {};
    };
  }, []);
  return (
    <div className="home">
      <Helmet>
        <title>{t("How to download equlix app for ios")}</title>

        <meta
          name="description"
          content={t(
            "How to download Equlix app on iOS. Step-by-step installation guide for the Equlix trading application.",
          )}
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <div className="main-page w-100" ref={wrapperRef}>
        <Header />

        <div className="instruction_page">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="sticky-block text-white">
                  <h4 className="mb-4">{t("iOS Instructions")}</h4>

                  <ol>
                    <li>
                      <h5>{t("Open Safari browser")}</h5>
                      <p>
                        {t(
                          "iOS devices only support Add to Home Screen in Safari.",
                        )}
                      </p>
                    </li>

                    <li>
                      <h5>{t("Tap the Share icon")}</h5>
                      <p>
                        {t(
                          "The share icon is located at the bottom of the browser.",
                        )}
                      </p>
                    </li>

                    <li>
                      <h5>{t("Select Add to Home Screen")}</h5>
                      <p>{t("Scroll and tap on Add to Home Screen.")}</p>
                    </li>

                    <li>
                      <h5>{t("Confirm")}</h5>
                      <p>
                        {t(
                          "Tap Add to place the app icon on your home screen.",
                        )}
                      </p>
                    </li>
                  </ol>
                </div>
                <div className="video-wrapper">
                  <video playsInline loop muted autoPlay>
                    <source src={iossequenceVideo} type="video/mp4" />
                  </video>
                  {/* <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        preload="auto"
                    >
                        <source src={iossequenceVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video> */}
                </div>
                <div
                  className={`inner-content ${isActive ? "show_content" : ""}`}
                >
                  <h3>Trading App for iPhone</h3>
                  <p>
                    Are you looking for an effective and convenient application
                    for successful trading on iPhone? Equlix is your reliable
                    companion in the world of financial opportunities. Our
                    innovative application is designed specifically for iOS. We
                    have combined modern technologies and efficient financial
                    solutions to provide a high-quality online trading
                    experience. With Equlix, you get access to financial markets
                    and can trade with confidence in reliability and
                    convenience. Trust the platform and move toward your
                    financial goals with ease.
                  </p>
                  <h4>Why is Equlix a good app?</h4>
                  <p>
                    Equlix is a modern trading platform that offers its users
                    several key advantages. The first is an intuitive interface
                    that makes the platform comfortable and easy to use, even
                    for beginners. The second advantage is fast and reliable
                    trade execution, allowing users to respond to market changes
                    in real time.
                  </p>

                  <p>
                    In addition, Equlix provides a wide range of assets,
                    including currency pairs, indices, and commodities, helping
                    traders diversify their portfolios and expand trading
                    opportunities.
                  </p>

                  <p>
                    Equally important, Equlix offers educational materials and
                    demo accounts, enabling users to develop skills and test
                    strategies without financial risk. Security and
                    confidentiality of user data and funds are top priorities,
                    supported by modern encryption technologies.
                  </p>
                  <p>
                    Equlix provides everything needed to participate in
                    financial markets, offering powerful tools and educational
                    resources for traders of all experience levels.
                  </p>
                  <h4>How to start using the Equlix app on iOS:</h4>

                  <ol>
                    <li>Launch the Safari browser.</li>
                    <li>
                      If you are using another browser, open this page in
                      Safari.
                    </li>
                    <li>Tap “Share.”</li>
                    <li>
                      Select the Share icon at the bottom of the screen to open
                      the menu.
                    </li>
                    <li>Choose “Add to Home Screen.”.</li>
                    <li>Confirm the action by tapping “Done.”</li>
                  </ol>
                  <p>
                    Take the opportunity to start online trading on your iPhone
                    today. Whether you are a beginner or an experienced trader,
                    the Equlix app is designed for all users. Add Equlix to your
                    home screen and begin your journey toward your financial
                    goals.
                  </p>
                  <h4>Risk notice:</h4>
                  <p>
                    Trading financial instruments involves significant risk.
                    Always follow a sound capital management strategy.
                    Investments may generate profits but can also result in
                    losses, so it is important to carefully evaluate strategies
                    and manage your investments responsibly.
                  </p>
                </div>
                <div className="ShowHideBtn">
                  <Link
                    className="showMore"
                    onClick={() => setIsActive(!isActive)}
                  >
                    Show more
                  </Link>
                  <Link
                    className="showLess"
                    onClick={() => {
                      setIsActive(!isActive);
                      window.scrollTo({ top: 0, behavior: "instant" });
                    }}
                  >
                    Show less
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default IosGuide;
